import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { getCourseRegistrationByIdApi } from '../../../Api/Registration';
import { fetchUserByIdApi } from '../../../Api/user';
import { addRegistrationCommentApi, getRegistrationCommentApi } from '../../../Api/RegistrationComments'
import { CourseDetails } from './RegistrationForm Components/CourseDetails';
import AssignBatch from './RegistrationForm Components/AssignBatch';

import { FaEdit, FaPlus } from "react-icons/fa";
import { getCourseOfferingApi } from '../../../Api/CourseOffering';
import { getCourseTypeApi } from '../../../Api/CourseType';
import { getCourseApi } from '../../../Api/Course';
import SideModal from '../../general/Sidemodal';
import { UserForm } from '../../../common/components/UserForm';
import { formatDate } from '../../general/FormatDateTime';

interface Props {
    url: string;
}

interface CourseRegistration {
    id: string;
    courseOfferingId: string;
    courseName: string | null;
    courseType: string | null;
    courseNameId: string | null;
    courseTypeId: string | null;
    userId: string;
    duration: any;
    customDuration: string | null;
    timeZone: string;
    timeRange: string;
    status: string;
    updatedBy: string;
    updatedOn: string;
}
interface User {
    id: string;
    name: string;
    mobile: string;
    email: string;
    address: string;
    roleType: number;
    gender: number;
}
interface Comments {
    id: string;
    courseRegistrationId: string;
    author: string;
    comment: string;
    updatedBy: string;
    updatedOn: string;
}

export function RegistrationForm({ url }: Props) {
    const location = useLocation();
    const { id } = location.state || {};
    const [CommentLoader, setCommentLoader] = useState<boolean>(false);
    const [userDetails, setUserDetails] = useState<User>();
    const [CommentsList, setCommentsList] = useState<Comments[]>([]);
    const [commentInput, setCommentInput] = useState<string>('');
    const [FetchedCourseRegistration, setFetchedCourseRegistration] = useState<CourseRegistration>();

    const [assignModal, setAssignModal] = useState(false);

    const handleApiCallClick = async () => {
        const FetchedComments = await getRegistrationCommentApi(id, url) as any[];
        const CourseRegResponce = await getCourseRegistrationByIdApi(id, url) as CourseRegistration
        
        const fetchedCourseOfferings: any = await getCourseOfferingApi(url);

        const fetchedCourseTypes: any = await getCourseTypeApi(url);

        const fetchedCoursesData: any = await getCourseApi(url);


        const courseOffering = fetchedCourseOfferings.find((offering: any) => offering.id === CourseRegResponce?.courseOfferingId);

        if (courseOffering) {

            const course = (fetchedCoursesData as any[]).find((c: any) => c.id === courseOffering.courseId);
            const courseName = course ? course.name : "Unknown Course";

     
            const courseType = fetchedCourseTypes.find((ct: any) => ct.id === courseOffering.courseTypeId);
            const courseTypeName = courseType ? courseType.name : "Unknown Course Type";

       
            const updatedRegistration = {
                ...CourseRegResponce,
                courseName: courseName,
                courseType: courseTypeName,
                courseNameId: courseOffering.courseId,
                courseTypeId: courseOffering.courseTypeId,
            };




            if (updatedRegistration.duration <= 3) {
                setFetchedCourseRegistration(updatedRegistration);
            } else if (updatedRegistration.duration > 3) {
                setFetchedCourseRegistration({
                    ...updatedRegistration,
                    duration: 'custom',
                    customDuration: updatedRegistration.duration
                });
            }
        }


        const FetchedUsers = await fetchUserByIdApi(url, CourseRegResponce.userId) as User;
        setUserDetails(FetchedUsers);

        // Add userName to each comment
        const commentsWithUserNames = FetchedComments.map(comment => {
            const parsedDate = comment.updatedOn ? new Date(comment.updatedOn) : new Date(0); // Handle undefined case

            return {
                ...comment,
                updatedOn: comment.updatedOn ? formatDate(comment.updatedOn) : "Unknown Date",
                rawUpdatedOn: parsedDate // Store original date for sorting
            };
        }).sort((a, b) => b.rawUpdatedOn.getTime() - a.rawUpdatedOn.getTime()); // Sort by newest first


        setCommentsList(commentsWithUserNames);

    }

    useEffect(() => {
        handleApiCallClick();
    }, [id]);

    const handleCommentSubmit = async () => {
        setCommentLoader(true);
        if (commentInput.trim() === '') {
            toast.error('Comment cannot be empty');
            return;
        }

        try {
            await addRegistrationCommentApi(id, commentInput, url);
            setCommentInput('');
            handleApiCallClick();
            toast.success('Comment added successfully');
        } catch (error) {
            console.error('Error adding comment:', error);
            toast.error('Failed to add comment. Please try again.');
        }
        setCommentLoader(false);
    };


    const [editUserModal, setEditUserModal] = useState(false);
    const [editUserId, setEditUserId] = useState<string | null>(null);

    const handleEditClick = (
        event: React.MouseEvent,
        id: string
    ) => {
        event.preventDefault();
        setEditUserModal(true);
        setEditUserId(id);
    };

    return (
        <div className="max-w-6xl p-6 max-sm:p-1">
            <h2 className="text-3xl font-bold text-blue-600 mb-5 flex items-center">
                Edit Registrations
            </h2>

            {/* User Information */}
            <div className="p-5 my-6 border border-gray-200 shadow-lg">
                <h2 className="text-2xl font-semibold mb-6">
                    User Information</h2>
                <div className="ml-4">
                    <div className="mt-4 grid grid-cols-2 gap-4">
                        <div>
                            <p className="text-gray-500">Name</p>
                            <p className="font-medium text-gray-800">{userDetails?.name || 'Not available'}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Email</p>
                            <p className="font-medium text-gray-800">{userDetails?.email ? userDetails.email : "Not provided"}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Mobile</p>
                            <p className="font-medium text-gray-800">{userDetails?.mobile ? userDetails.mobile : "Not provided"}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Gender</p>
                            <p className="font-medium text-gray-800">
                                {userDetails && userDetails.gender !== undefined
                                    ? userDetails.gender === 1
                                        ? "Male"
                                        : userDetails.gender === 2
                                            ? "Female"
                                            : "Other"
                                    : "Not provided"}
                            </p>
                        </div>
                    </div>
                    <div className="flex-grow ml-0 mt-4">
                        <button
                            type="button"
                            onClick={(event) =>
                                handleEditClick(
                                    event,
                                    userDetails.id
                                )
                            }
                            className="flex items-center justify-center w-fit px-4 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                        >
                            <FaEdit className="mr-2" />  Edit user
                        </button>
                    </div>
                </div>
            </div>



            {/* courseInformation */}
            <div className='border border-gray-200 shadow-lg my-4'>
                <CourseDetails url={url} FetchedCourseRegistration={FetchedCourseRegistration} userDetails={userDetails} handleApiCallClick={handleApiCallClick} setAssignModal={setAssignModal} />
            </div>

            {/* Comments */}
            <div className=" ">
                <div className={`p-4 border my-6 border-gray-200 shadow-lg rounded-lg ${CommentLoader ? "filter blur-[1px]" : ""}`}>
                    <h2 className="text-2xl font-semibold  mb-6">Comments</h2>

                    <div className="m-4">
                        <textarea
                            name="comments"
                            value={commentInput}
                            onChange={(e) => setCommentInput(e.target.value)}
                            placeholder="Add a new comment here (e.g., 'Not answering phone and reason')"
                            className="w-full h-24 p-2 rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                            maxLength={499}
                        />
                        <div className="space-y-2 text-sm text-gray-500">
                            <p>{500 - commentInput.length} characters remaining</p>
                            <div className="flex-grow ml-0 mt-4">
                                <button
                                    onClick={handleCommentSubmit}
                                    className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                                >
                                    <FaPlus className="mr-2" /> Add Comment
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-3 m-4 overflow-y-auto max-h-96">
                        {CommentsList.map((comment, index) => (
                            <div key={index} className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <div className="flex items-center justify-between mb-2">
                                    <div className="flex items-center gap-2">
                                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-semibold">
                                            {comment.author.charAt(0)}
                                        </span>
                                        <span className="font-medium text-gray-700">{comment.author}</span>
                                    </div>
                                    <span className="text-sm text-gray-500">{comment.updatedOn}</span>
                                </div>
                                <p className="text-gray-700 ml-10">{comment.comment}</p>
                            </div>
                        ))}
                        {CommentsList.length === 0 && (
                            <div className="flex flex-col items-center justify-center text-center bg-white p-6 rounded-lg max-w-lg mx-auto">
                                <h2 className="text-xl font-semibold text-gray-800">No Comments Yet</h2>
                            </div>
                        )}

                    </div>
                </div>

                {/* Loader (moved outside the blurred div) */}
                {CommentLoader && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
                        <div className="w-12 h-12 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                    </div>
                )}
            </div>

            {/* AssignModel */}
            {
                FetchedCourseRegistration?.status === "Ready for batch" ? (
                    <SideModal isOpen={assignModal} onClose={() => setAssignModal(false)}>
                        <AssignBatch url={url} assignModal={assignModal} setAssignModal={setAssignModal} userId={userDetails?.id} handleApiCallClick={handleApiCallClick} CourseRegistration={FetchedCourseRegistration} />
                    </SideModal>

                ) : ""
            }
            <SideModal isOpen={editUserModal} onClose={() => setEditUserModal(false)}>
                <UserForm onClose={() => setEditUserModal(false)} userId={editUserId} url={url} />
            </SideModal>

        </div >

    );
};

export default RegistrationForm;